<template>
  <div v-if="state.list.length > 0">
    <div class="text-xl font-bold">
      NFT Collections/PASS/Crendentials
      <span class="text-xs text-gray-level font-normal" v-if="holderSum > 0"
        >({{ localeNumber(holderSum) }}holders)</span
      >
    </div>

    <div class="grid grid-cols-5 md:grid-cols-6 mt-4 gap-2">
      <div v-for="(item, i) in state.list.slice(0, 12)" :key="i">
        <a
          :href="item.link"
          target="_blank"
          v-if="
            ![
              'bonding_curve',
              'fixed_price',
              'nft_base',
              'token_base',
            ].includes(item.type)
          "
        >
          <div class="flex flex-col items-center group">
            <div class="relative">
              <UiImg
                class="w-14 h-14 rounded-full overflow-hidden"
                :src="item.image || require('@/assets/icons/nftnologo.avif')"
              ></UiImg>
              <img
                v-if="item.type == 'OAT'"
                class="w-5 h-5 absolute bottom-0 right-0"
                src="@/assets/icons/oat.avif"
                alt=""
              />
              <img
                v-if="item.type == 'POAP'"
                class="w-5 h-5 absolute bottom-0 right-0"
                src="@/assets/icons/poap.avif"
                alt=""
              />
            </div>

            <div
              class="
                text-xs
                mt-2
                text-center
                group-hover:underline group-hover:opacity-70
                line-clamp-2
              "
            >
              {{ item.name }}
            </div>
          </div>
        </a>
        <router-link :to="`/dao/${$route.params.name}/NFTPASS`" replace v-else>
          <div class="flex flex-col items-center group">
            <div class="relative">
              <UiImg
                class="w-14 h-14 rounded-full overflow-hidden"
                :src="item.image || require('@/assets/icons/nftnologo.avif')"
              ></UiImg>

              <img
                v-if="['nft_base', 'token_base'].includes(item.type)"
                class="w-5 h-5 absolute bottom-0 right-0"
                src="@/assets/icons/sb.avif"
                alt=""
              />
              <img
                v-if="item.type == 'bonding_curve'"
                class="w-5 h-5 absolute bottom-0 right-0"
                src="@/assets/icons/bc.avif"
                alt=""
              />
              <img
                v-if="item.type == 'fixed_price'"
                class="w-5 h-5 absolute bottom-0 right-0"
                src="@/assets/icons/fp.avif"
                alt=""
              />
            </div>

            <div
              class="
                text-xs
                mt-2
                text-center
                group-hover:underline group-hover:opacity-70
              "
            >
              {{ item.name }}
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <router-link
      :to="`/dao/${$route.params.name}/NFTPASS`"
      v-if="state.list.length > 12"
      class="
        bg-white-005
        flex
        items-center
        justify-center
        rounded
        h-10
        mt-6
        hover:opacity-70
      "
    >
      <div class="mr-2">See more</div>
      <i class="iconfont icon-right"></i>
    </router-link>
  </div>
</template>

<script setup>
import { queryOvDaoPass } from '@/api/dao';
import { useReqByBool } from '@/hooks';
import { computed, inject, onMounted, reactive } from 'vue';
import UiImg from '@/components/UiImg.vue';
import { localeNumber } from '@/utils';
import { useRoute } from 'vue-router';

const $route = useRoute();

const daoPageInfo = inject('daoPageInfo');

const state = reactive({
  list: [],
});

const holderSum = computed(() => state.list.reduce((a, b) => a + b.holders, 0));

const { loadData, loading } = useReqByBool(async () => {
  const res = await queryOvDaoPass(daoPageInfo.vueState.info.id);
  console.log(res);
  state.list = res;
});

onMounted(() => {
  loadData();
});
</script>

<style lang="scss" scoped></style>
